export * from "./text-media-editor.component";
